import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-ask-phone',
  templateUrl: './ask-phone.page.html',
  styleUrls: ['./ask-phone.page.scss'],
})
export class AskPhonePage implements OnInit {
  formatedPhone: string;
  phoneForm: FormGroup;
  phone = '+1';
  constructor(
    private formBuilder: FormBuilder,
    public globals: GlobalVariable,
    public server: ServerService,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController
  ) {}

  ngOnInit() {
    this.phoneForm = this.formBuilder.group({
      phone: new FormControl(
        '',
        Validators.compose([
          Validators.maxLength(10),
          Validators.pattern('[0-9]*'),
          Validators.required,
        ])
      ),
    });
  }
  close() {
    this.modalCtrl.dismiss();
    this.globals.laterAskPhone = true;
  }
  numberChange() {
    console.log('here');
    this.formatedPhone = String(this.phoneForm.value.phone);
    var cleaned = ('' + this.formatedPhone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      console.log(this.formatedPhone);
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  saveSettings(e) {
    console.log(e.detail.checked);
    localStorage.setItem('askforphone', JSON.stringify(e.detail.checked));
  }
  async submit(form) {
    let udid = localStorage.getItem('udid');
    let email = localStorage.getItem('userEmail');

    var cleaned = ('' + this.phoneForm.value.phone).replace(/\D/g, '');
    this.phoneForm.setValue({ phone: cleaned });
    if (this.phoneForm.valid) {
      const loading = await this.loadingCtrl.create({
        message: 'Updating phone...',
      });
      loading.present();
      this.server
        .UpdateUserProfile('', email, '', '', this.phone + cleaned, udid)
        .subscribe(
          (res) => {
            console.log(res);
            loading.dismiss();

            if (res.success) {
              localStorage.setItem('askforphone', 'false');
              // if(cleaned)
              localStorage.setItem('userphone', res.updated_data.phone);
              this.globals.presentToast('Phone number updated...');
              this.close();
            } else {
              this.globals.presentToast('Failed to update phone. Try again');
            }
          },
          (err) => {
            loading.dismiss();

            this.globals.presentToast('Network Error');
          }
        );
    } else {
      console.log(this.phoneForm.value);
      this.globals.presentToast('Invalid Phone number');
    }
  }
}
